import React from 'react';

import { Button } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => {
  return {
    button: {
      borderRadius: 0,
      boxShadow: 'none',
      '&.MuiButton-containedPrimary:not(.Mui-disabled)': {
        color: '#fff',
        backgroundColor: '#b4bd00'
      },
      [theme.breakpoints.up('xs')]: {
        fontSize: 16
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 18
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 22
      }
    }
  };
});

export default function CoolfoodButton(props) {
  const classes = useStyles();

  return (
    <Button className={classes.button} {...props}>
      {props.children}
    </Button>
  );
}
